"use client";

import { useEffect } from "react";

// Background notification handler for cross-page notifications
const BackgroundNotificationHandler = () => {
  useEffect(() => {
    // Store notification state in sessionStorage to persist across page navigation
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        // Page became visible, check for pending notifications
        const pendingNotifications = sessionStorage.getItem("pendingChatNotifications");
        if (pendingNotifications) {
          try {
            const notifications = JSON.parse(pendingNotifications);
            notifications.forEach((notification: any) => {
              // Re-dispatch the event when page becomes visible
              const event = new CustomEvent("stream-chat-message-new", {
                detail: notification,
              });
              window.dispatchEvent(event);
            });
            // Clear pending notifications
            sessionStorage.removeItem("pendingChatNotifications");
          } catch (error) {
            console.error("Error processing pending notifications:", error);
          }
        }
      }
    };

    // Listen for page visibility changes
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Listen for chat messages and store them if page is not visible
    const handleChatMessage = (event: CustomEvent) => {
      if (document.visibilityState === "hidden") {
        // Page is not visible, store notification for later
        const pendingNotifications = sessionStorage.getItem("pendingChatNotifications");
        const notifications = pendingNotifications ? JSON.parse(pendingNotifications) : [];
        notifications.push(event.detail);
        sessionStorage.setItem("pendingChatNotifications", JSON.stringify(notifications));
      }
    };

    window.addEventListener("stream-chat-message-new", handleChatMessage as EventListener);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("stream-chat-message-new", handleChatMessage as EventListener);
    };
  }, []);

  return null;
};

export default BackgroundNotificationHandler;
